// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import taskTypeEntity from './entities/task-type.json';
import taskTypeMenu from '../pages/task-type/menu.json';
import taskTypeFullForm from '../pages/task-type/forms/full.json';
import taskTypeContextForm from '../pages/task-type/forms/context.json';
import taskTypeMiniForm from '../pages/task-type/forms/mini.json';
import taskTypeLookupForm from '../pages/task-type/forms/lookup.json';
import taskTypeTableView from '../pages/task-type/views/table.json';
import taskTypeDashboardView from '../pages/task-type/views/dashboard.json';

/** Тип запису «Тип завдання» зі сторінками пакета: меню, форми та подання з pages/task-type/. */
export const taskTypeDefinition: IRecordTypeDefinition = {
  ...taskTypeEntity,
  views: assembleViewSet({
      table: taskTypeTableView,
      dashboard: taskTypeDashboardView,
  }),
  form: taskTypeFullForm,
  forms: { full: taskTypeFullForm, context: taskTypeContextForm, mini: taskTypeMiniForm, lookup: taskTypeLookupForm },
  menu: taskTypeMenu,
} as IRecordTypeDefinition;
